/** Accept display formatting, but require a plausible complete subscriber number. */
export function phoneValidationError(phone: string, required = false): string | null {
  const value = phone.trim();
  if (!value) return required ? 'Phone number is required' : null;
  const digits = value.replace(/\D/g, '');
  if (!/^\+?[\d\s().-]+$/.test(value) || digits.length < 7 || digits.length > 15) {
    return 'Enter a valid phone number with 7 to 15 digits';
  }
  return null;
}
